<template>
    <div :class="{'check---item': options.rules && options.rules.length,'is---error': isError,}">
        <el-select v-if="options.type === 'select'"
                   v-model="modelValue"
                   :placeholder="options.placeholder || '请选择'"
                   :clearable="options.clearable"
                   :size="size">
            <el-option v-for="i in options.options"
                       :key="i.value"
                       :label="i.label"
                       :value="i.value">
            </el-option>
        </el-select>

        <div v-else-if="options.type === 'choose'" class='input-box' @click="showDialog(options.method)">
            <span v-if="!modelValue" style="float:left;padding-left:10px">点击选择{{modelValue}}</span>
            <!--            <el-tag effect="dark" size="medium" style="float:left;margin-top:5px;margin-right: 5px">-->
            <!--                {{modelValue}}-->
            <!--            </el-tag>-->
            <span v-else style="text-align: center">{{modelValue}}</span>
        </div>

        <el-date-picker v-else-if="options.type === 'date'"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="modelValue"
                        style="width: 100%;">
        </el-date-picker>

        <el-button v-else-if="options.type === 'file'"
                   size="medium"
                   type="primary"
                   @click="showUpload"
                   icon="el-icon-upload">
            附件上传
        </el-button>

        <el-switch v-else-if="options.type === 'switch'" v-model="modelValue">

        </el-switch>

        <el-input v-else-if="options.type === 'inputSel'"
                  v-model="modelValue"
                  :type="'text'"
                  :placeholder="options.placeholder || '请输入或选择'"
                  :clearable="options.clearable"
                  :size="size">
            <el-button slot="append" icon="el-icon-plus" style="padding: 0px"
                       @click="showDialog(options.method)"></el-button>
        </el-input>

        <el-input v-else
                  v-model="modelValue"
                  :type="options.type === undefined ? 'text' : options.type"
                  :placeholder="options.placeholder || options.title"
                  :clearable="options.clearable"
                  :size="size"
                  :autosize="{ minRows: 1, maxRows: 4}">
        </el-input>
        <div v-if="isError && !hiddenMessage" class="item---error">
            {{ message }}
        </div>

        <fileupload v-if="showUploadDialog"
                    :formData="formData"
                    @close="closeUploadDialog">
        </fileupload>

        <selWareHouse v-if="showWareHouse"
                      :warehouseId="warehouseId"
                      @closeDialog="closeDialog"
                      @checkRow="checkWareHouse">
        </selWareHouse>
        <selSupplier v-if="showSupplier"
                     :supplierId="supplierId"
                     @closeDialog="closeDialog"
                     @checkRow="checkSupplier">
        </selSupplier>
        <selAccTitle v-if="showAccTitle"
                     :accTitleId="accTitleId"
                     @closeDialog="closeDialog"
                     @checkRow="checkAccTitle">
        </selAccTitle>
        <selBill v-if="showBill"
                     :relaBillId="relaBillId"
                     @closeDialog="closeDialog"
                     @checkRow="checkBill">
        </selBill>
        <selPrice v-if="showPrice"
                 :productInfoId="productInfoId"
                 @closeDialog="closeDialog"
                 @checkRow="checkCostPrice">
        </selPrice>
        <selSerialNo v-if="showSerialNo"
                  @closeDialog="closeDialog"
                  @addSerialNo="addSerialNo">
        </selSerialNo>
    </div>
</template>

<script>
    import Schema from "async-validator";
    import fileupload from '@/components/tools/fileupload/dialog'
    import selWareHouse from '@/components/page/stock/warehouse/selWareHouse'
    import selSupplier from '@/components/page/supplier/supplier/selSupplier'
    import selAccTitle from '@/components/page/finance/accountingtitle/selAccTitle'
    import selBill from '@/components/page/finance/voucher/selBill'
    import selPrice from '@/components/page/wzgl/wzgl/selWzPrice'
    import selSerialNo from '@/components/page/wzgl/wzgl/selSerialNo'

    export default {
        name: "EditItem",
        components: {
            fileupload, selWareHouse, selSupplier,selAccTitle,selBill,
            selPrice,selSerialNo
        },
        props: {
            data: {
                type: Array,
                default: () => [],
            },
            isPerview: {
                type: Boolean,
                default: false
            },
            conf: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number,
                default: 0,
            },
            value: {
                type: [String, Number, Boolean, Array],
                default: "",
            },
            options: {
                type: Object,
                required: true
            },
            size: {
                validator: function (value) {
                    // 这个值必须匹配下列字符串中的一个
                    return ["medium", "small", "mini", ""].indexOf(value) !== -1;
                },
                default: "",
            },
            // 是否隐藏 Message
            hiddenMessage: {
                type: Boolean,
                default: false,
            },
            formData: {
                type: Object,
                default: () => {
                }
            },
        },
        watch: {
            data: {
                handler(val) {
                    this.dataList = val;
                },
                deep: true,
            }
        },
        data() {
            return {
                showUploadDialog: false,
                dataList: [],
                isError: false,
                message: "",
                initValue: this.value,

                showWareHouse: false,
                warehouseId: "",
                showSupplier: false,
                supplierId: "",
                showAccTitle:false,
                accTitleId:"",
                showBill:false,
                relaBillId:"",
                showPrice:false,
                productInfoId:"",
                showSerialNo:false,
            };
        },
        computed: {
            modelValue: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit("input", val);
                },
            },
        },
        mounted() {
            if (this.options.type === 'switch') {
                if (!this.modelValue) {
                    this.modelValue = false
                }
            }
            if (this.options.type === 'file') {
                // const table_key = this.conf.vModel + '_' + this.rowIndex;
                // this.formData[table_key] = this.value;
            }
            if (this.options.type === 'choose') {
                //
            }
        },
        methods: {
            // submitOrg(data) {
            //     this.modelValue = data
            // },
            // 字段验证
            validateRow() {
                // 没有规则时直接返回成功
                if (!(this.options.rules && this.options.rules.length)) {
                    return new Promise((resolve) => {
                        resolve(true);
                    });
                }

                return new Promise((resolve, reject) => {
                    const validator = new Schema({value: this.options.rules});
                    validator.validate({value: this.value}, (errors) => {
                        if (errors) {
                            this.isError = true;
                            this.message = errors[0].message;
                            reject(errors);
                        } else {
                            this.isError = false;
                            this.message = "";
                            resolve(true);
                        }
                    });
                });
            },
            // 取消编辑
            // cancelEdit() {
            //     this.$emit("input", this.initValue);
            // },
            showUpload() {
                this.showUploadDialog = true;
            },
            closeUploadDialog() {
                this.showUploadDialog = false;
            },
            showDialog(method) {
                if (this.conf.disabled)
                    return;
                if (method == "warehouse") {
                    if(this.options.key == "intoWarehouseNo"){
                        this.warehouseId = this.formData.intoWarehouseId;
                    }else{
                        this.warehouseId = this.formData.warehouseId;
                    }
                    this.showWareHouse = true;
                }
                if (method == "supplier") {
                    this.supplierId = this.formData.supplierId;
                    this.showSupplier = true;
                }
                if (method == "accountingtitle") {
                    this.accTitleId = this.formData.accTitleId;
                    this.showAccTitle = true;
                }
                if (method == "bill") {
                    this.relaBillId = this.formData.relaBillId;
                    this.showBill = true;
                }
                if (method == "costPrice") {
                    this.productInfoId = this.formData.productInfoId;
                    this.showPrice= true;
                }
                if (method == "serialNo") {
                    this.showSerialNo= true;
                }
            },
            closeDialog() {
                this.showWareHouse = false;
                this.showSupplier = false;
                this.showAccTitle = false;
                this.showPrice = false;
                this.showSerialNo =  false;
            },
            checkWareHouse(row) {
                if(this.options.key == "intoWarehouseNo"){
                    this.formData.intoWarehouseNo = row.warehouseNo;
                    this.formData.intoWarehouseId = row.warehouseId;
                }else{
                    this.formData.warehouseId = row.warehouseId;
                    this.formData.warehouseName = row.warehouseName;
                    this.formData.warehouseNo = row.warehouseNo;
                    this.initValue = row.warehouseNo;
                }
                this.showWareHouse = false;
                this.$emit("refreshTable");
            },
            checkSupplier(row) {
                this.formData.supplierId = row.supplierId;
                this.formData.supplierName = row.supplierName;
                this.initValue = row.supplierName;
                this.showSupplier = false;
                this.$emit("refreshTable");
            },
            checkAccTitle(row) {
                this.formData.accTitleId = row.id
                this.formData.accTitleName = row.name
                this.formData.accTitleCode = row.code
                this.initValue = row.accTitleName;
                this.showAccTitle = false;
                this.$emit("refreshTable");
            },
            checkBill(row) {
                this.formData.relaBillId = row.billId;
                this.formData.relaBillType = row.billType;
                this.formData.relaBillNo = row.billNo;
                this.formData.relaBillDate = row.billDate;
                this.initValue = row.billId;
                this.showBill = false;
                this.$emit("refreshTable");
            },
            checkCostPrice(row) {
                this.formData.costPrice = row.costPrice01;
                this.initValue = row.costPrice01;
                this.showPrice= false;
                this.$emit("refreshTable");
                this.$emit("input", this.initValue);
            },
            addSerialNo(serialNo){
                let taxTotal=this.formData.taxTotal;
                if(taxTotal==undefined || taxTotal==null || taxTotal=='' || taxTotal==0){
                    this.$message({message: '请先输入数量单价和小计', type: 'error'});
                    return false;
                }

                if(this.formData.serialNo==undefined) {
                    this.initValue = serialNo;
                    this.formData.serialNo= serialNo;
                    this.$emit("input", this.initValue);
                }else{
                    let formDataNew={};
                    formDataNew=JSON.parse(JSON.stringify(this.formData)),
                    formDataNew.serialNo=serialNo;
                    this.$emit("copyInput", formDataNew);
                }

                this.$emit("refreshTable");
            }
        },
    };
</script>

<style scoped>
    .input-box {
        padding-left: 6px;
        min-height: 30px;
        line-height: 30px;
        border: 1px solid #bfc1c4;
        background-color: #daecfa;
        border-radius: 4px;
        /*color: #b0b4bf;*/
        cursor: pointer;
    }

    .check---item {
        position: relative;
    }

    .is---error >>> .el-input__inner {
        border-color: #f56c6c;
    }

    .item---error {
        line-height: 16px;
        font-size: 12px;
        color: #f56c6c;
    }
</style>
